export enum ImportStatus {
    Created = 'STATUS_CREATED',
    Aborted = 'STATUS_ABORTED',
    Published = 'STATUS_PUBLISHED',
    Publishing = 'STATUS_PUBLISHING',
    DeleteExistingProducts = 'STATUS_DELETE_EXISTING',
    CreatingCategories = 'STATUS_CREATING_CATEGORIES',
    Calculating = 'STATUS_CALCULATING',
    ReadyToPublish = 'STATUS_READY_TO_PUBLISH',
    Receiving = 'STATUS_RECEIVING',
    Archived = 'STATUS_ARCHIVED',
    Scheduled = 'STATUS_SCHEDULED',
}
